import PreparatoryStandardsPage from './_PreparatoryStandardsPage'

export default function BreakerDFSettingsPage() {
  return <PreparatoryStandardsPage kind="breaker-df" />
}
